<style>
.bg-primary {
  background-color: #1a3665 !important;
}
.bg-active {
  background-color: #3e5d92;
}
.bg-subactive {
  background-color: #486ba7;
}
</style>
<template>
  <CCard>
    <CCardHeader class="bg-primary text-white border-0 font-weight-bold p-3 d-flex align-items-center">{{ this.$string.sidebar.menu_5.sub_menu.menu_10 }} {{ this.$string.sidebar.menu_5.sub_menu.menu_13 }}
      <CButton
        color="info"
        style="float:right;margin-right:10px"
        class="btn-md ml-auto"
      >Upload Template</CButton>
      <CButton
        color="success"
        style="float:right;margin-right:10px"
        class="btn-md float-right"
      >Download Template</CButton>
    </CCardHeader>
    <!-- Tabs -->
      <ul class="nav nav-tabs bg-active border-0" id="myTab" role="tablist">
        <li class="nav-item">
          <router-link
            to="/pelatihan/e-sertifikat"
          class="nav-link p-3 px-5 font-weight-bold text-white border-0"
            id="home-tab"
            data-toggle="tab"
            href="#home"
            role="tab"
            aria-controls="home"
            aria-selected="true"
          >{{ this.$string.sidebar.menu_5.sub_menu.menu_10 }}</router-link>
        </li>
        <li class="nav-item">
          <router-link
            to="/pelatihan/workshop/instruktur"
            class="nav-link p-3 px-5 font-weight-bold text-white"
            style="background-color: #486ba7;"
            id="profile-tab"
            data-toggle="tab"
            href="#profile"
            role="tab"
            aria-controls="profile"
            aria-selected="false"
          >{{ this.$string.sidebar.menu_5.sub_menu.menu_13 }}</router-link>

        </li>
      </ul>
    <!-- Data E-Certificate -->
    <CCardBody>
      <CRow>
        <div class="col-sm-12 col-xl-12">
          <div class="form-group">
            <label for class="font-weight-bold">Pilih Pelatihan</label>
            <select class="form-control" name id>
              <option>Semua Data</option>
            </select>
          </div>
        </div>
      </CRow>
      <CRow>
        <div class="col-sm-12 col-xl-2">
          <div class="form-group">
            <label for>Data Perhalaman</label>
            <select class="form-control" name id>
              <option>10</option>
              <option>25</option>
              <option>100</option>
              <option>Semua Data</option>
            </select>
          </div>
        </div>
        <div class="col-sm-12 col-xl-3 ml-auto">
          <div class="form-group">
            <label for>Pencarian</label>
            <input type="text" name id class="form-control" placeholder="Cari Data ..." />
          </div>
        </div>
      </CRow>
      <CRow>
        <CCol lg="12" class="table-responsive">
          <CDataTable style="widht:100% !important" :items="items" :fields="fields" hover sorter>
            <template #no="{item}">
              <td class="py-2">{{ item.no }}</td>
            </template>
            <template>
              <td>
                <i class="fa fa-file" aria-hidden="true"></i>
              </td>
            </template>
            <template #_status="{item}">
              <td class="py-2 text-center">
                <font-awesome-icon icon="check" class="text-success" v-if="item._status == 1" />
                <font-awesome-icon icon="times" class="text-danger" v-else />
              </td>
            </template>
            <template #aksi="{item, index}">
              <td class="py-2 d-flex align-items-center text-center">
                <CButton color="info" class="btn-sm text-white mr-1" square>
                  <font-awesome-icon icon="edit" />
                </CButton>&nbsp;&nbsp;
                <CButton color="danger" class="btn-sm" square @click="deleteData(item, index)">
                  <font-awesome-icon icon="trash" />
                </CButton>
              </td>
            </template>
          </CDataTable>
          <CPagination style="float:right" :active-page.sync="currentPage" :pages="10" responsive />
        </CCol>
      </CRow>
      <!-- Modal Tambah -->
      <CModal
        title="Modal title"
        :show.sync="myModal"
        :no-close-on-backdrop="true"
        :centered="true"
      >
        <CForm>
          <CRow>
            <div class="modal-body">
              <CForm>
                <CRow>
                  <CCol sm="12">
                    <CInput
                      class="font-weight-bold"
                      label="Template E-Certificate"
                      placeholder="Masukkan nama template"
                    />
                  </CCol>

                  <CCol sm="12">
                    <label for="uid-zwqayuopq3" class="font-weight-bold input-group">Background E-Certificate</label>
                  </CCol>
                </CRow>
                <input type="file" id="verborgen_file" />
                <input
                  type="button"
                  class="btn btn-block btn-primary"
                  value="Upload"
                  id="uploadButton"
                />
                <br />
                <br />
                <div id="pf_foto">
                  <div class="h-100">
                    <div class="row justify-content-center text-center h-50">
                      <h5 class="mt-5">Ini Nama Pelatihan</h5>
                    </div>
                    <div class="row justify-content-center text-center h-50">
                      <h4 class="font-weight-bold">Ini Nama Anggota</h4>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <CCol sm="12">
                    <label for class="font-weight-bold">Status</label>
                    <br />
                    <div class="d-flex align-items-center">
                      <div class="custom-control custom-radio custom-control-inline">
                        <input
                          type="radio"
                          class="custom-control-input"
                          name="customRadio"
                          id="aktif"
                          value="1"
                        />
                        <label class="custom-control-label" for="aktif">Aktif</label>
                      </div>
                      <div class="custom-control custom-radio custom-control-inline">
                        <input
                          type="radio"
                          class="custom-control-input"
                          name="customRadio"
                          id="tidak_aktif"
                          value="0"
                        />
                        <label class="custom-control-label" for="tidak_aktif">Tidak Aktif</label>
                      </div>
                    </div>
                  </CCol>
                </div>
              </CForm>
            </div>
          </CRow>
        </CForm>
        <template #header>
          <h6 class="modal-title h4 font-weight-bold">Tambah</h6>
        </template>
        <template #footer>
          <CButton @click="myModal = false" color="danger">Tutup</CButton>
          <CButton @click="postData" type="submit" color="success">Simpan</CButton>
        </template>
      </CModal>
      <!-- End Modal -->
    </CCardBody>
    <!-- End Data E-Certificate -->
  </CCard>
</template>
<style scoped>
#pf_foto {
  /* background-image: url("");
  background-size: cover;
  background-position: center;
  height: 350px; */
}
.btn-primary {
  background-color: #1a3665 !important;
}
</style>
<script>
const items = [
  {
    no: "1",
    no_agt: "51554",
    tahun: "2020",
    nama_peserta: "JOSEPH SISILO",
    kode_ppl: "PPL20027",
    nama_ppl: "PPL KSHUSUS STAF",
    // kap: "DRS. JOSEPH",
    // jam_masuk: "08:00",
    // jam_keluar: "16:00",
    // file: "img.png",
    _status: 1
  },
  {
    no: "2",
    no_agt: "51554",
    tahun: "2020",
    nama_peserta: "JOSEPH SISILO",
    kode_ppl: "PPL20027",
    nama_ppl: "PPL KSHUSUS STAF",
    // kap: "DRS. JOSEPH",
    // jam_masuk: "08:00",
    // jam_keluar: "16:00",
    // file: "img.png",
    _status: 0
  },
  {
    no: "3",
    no_agt: "51554",
    tahun: "2020",
    nama_peserta: "JOSEPH SISILO",
    kode_ppl: "PPL20027",
    nama_ppl: "PPL KSHUSUS STAF",
    // kap: "DRS. JOSEPH",
    // jam_masuk: "08:00",
    // jam_keluar: "16:00",
    // file: "img.png",
    _status: 1
  }
];

const fields = [
  {
    key: "no",
    label: "No",
    sorter: true,
    filter: false,
    _style: "width: 2%"
  },
  {
    key: "no_agt",
    label: "No Peserta",
    sorter: true,
    filter: false
  },
  {
    key: "nama_peserta",
    label: "Nama Peserta",
    sorter: true,
    filter: false
  }, 
  {
    key: "tahun",
    label: "Tahun",
    sorter: true,
    filter: false
  },
  {
    key: "kode_ppl",
    label: "Kode Pelatihan",
    sorter: true,
    filter: false
  },
  {
    key: "nama_ppl",
    label: "Nama Pelatihan",
    sorter: true,
    filter: false
  },  
  {
    key: "_status",
    _style: "text-align: center",
    sorter: false,
    filter: false
  },
  {
    key: "aksi",
    _style: "width: 13% text-align: center",
    sorter: false,
    filter: false
  }
];

export default {
  name: "Data Peserta",
  data() {
    return {
      items: items.map((item, id) => {
        return { ...item, id };
      }),
      formData: {
        judul: "",
        file: ""
      },
      formData: {
        deskripsi: "",
        file: ""
      },
      fileName: "Choose File...",
      fields,
      currentPage: 3,
      details: [],
      no: 1,
      status: false,
      myModal: false,
      horizontal: { label: "col-3", input: "col-9" },

      collapseDuration: 0,
      content: []
    };
  },
  mounted() {

    $("#verborgen_file").hide();
    $("#pf_foto").hide();
    $("#uploadButton").on("click", function() {
      $("#verborgen_file").click();
    });

    $("#verborgen_file").change(function() {
      var file = this.files[0];
      var reader = new FileReader();
      reader.onloadend = function() {
        $("#pf_foto").show();
        $("#pf_foto").css("background-image", 'url("' + reader.result + '")');
      };
      if (file) {
        reader.readAsDataURL(file);
      } else {
      }
    });
  },

  methods: {
    deleteData() {
      this.$swal
        .fire({
          title: "Peringatan!",
          text: "Apakah anda yakin ingin menghapus data ini?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Ya",
          cancelButtonText: "Tidak",
          confirmButtonColor: "#d33",
          cancelButtonColor: "#3085d6",
          reverseButtons: true
        })
        .then(result => {
          if (result.value) {
            const Toast = this.$swal.mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
              onOpen: toast => {
                toast.addEventListener("mouseenter", Swal.stopTimer);
                toast.addEventListener("mouseleave", Swal.resumeTimer);
              }
            });
            Toast.fire({
              icon: "success",
              title: "Data Berhasil Dihapus"
            });
          } else if (result.dismiss === Swal.DismissReason.cancel) {
            this.$swal.fire(
              "Cancelled",
              "Your imaginary file is safe :)",
              "error"
            );
          }
        });
    }
  }
};
</script>